import React, { FunctionComponent } from "react"

interface GamePadIconProps {
  color?: string
}

const GamePadIcon: FunctionComponent<GamePadIconProps> = ({
  color = "#EC4747",
}) => {
  return (
    <svg
      width="66"
      height="56"
      viewBox="0 0 66 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2398_2196)">
        <path
          d="M41.8663 12.334H24.133C22.4835 12.3344 20.8927 12.9463 19.6681 14.0514C18.4435 15.1566 17.6721 16.6765 17.503 18.3173C17.493 18.404 17.4863 18.4857 17.4747 18.5707C17.3397 19.694 16.333 28.094 16.333 30.6673C16.333 31.9934 16.8598 33.2652 17.7975 34.2029C18.7352 35.1405 20.0069 35.6673 21.333 35.6673C22.9997 35.6673 23.833 34.834 24.6663 34.0007L27.023 31.644C27.648 31.0188 28.4957 30.6675 29.3797 30.6673H36.6197C37.5037 30.6675 38.3514 31.0188 38.9763 31.644L41.333 34.0007C42.1663 34.834 42.9997 35.6673 44.6663 35.6673C45.9924 35.6673 47.2642 35.1405 48.2019 34.2029C49.1396 33.2652 49.6663 31.9934 49.6663 30.6673C49.6663 28.0923 48.6597 19.694 48.5247 18.5707C48.513 18.4873 48.5063 18.404 48.4963 18.319C48.3277 16.6778 47.5564 15.1575 46.3318 14.052C45.1072 12.9466 43.5161 12.3344 41.8663 12.334Z"
          fill="#EC4747"
          stroke="#EC4747"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23 22.334H29.6667"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.333 19V25.6667"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38 24H38.0163"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43 20.666H43.0163"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2398_2196"
          x="-1"
          y="-6"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2398_2196"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.92549 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.32 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2398_2196"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2398_2196"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default GamePadIcon
